import emailjs from "@emailjs/browser";
import { useState } from "react";
import './page.css';
import ImageLogo from '../Images/Cigna22Logo.png';
import LinkedIn from '../Images/linkedin icon.png';
import Facebook from '../Images/facebook logo icon.png';
import Instagram from '../Images/instagram icon.png';

function Page() {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        service: "",
        message: "",
    });
    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };
    const sendEmail = (e) => {
        e.preventDefault();
        emailjs
            .send(
                process.env.REACT_APP_EMAILJS_SERVICE_ID,
                process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
                {
                    name: formData.name,
                    email: formData.email,
                    service: formData.service,
                    message: formData.message,
                },
                process.env.REACT_APP_EMAILJS_PUBLIC_KEY
            )
            .then(() => {
                alert("Email Sent Successfully!");

                setFormData({
                    name: "",
                    email: "",
                    service: "",
                    message: "",
                });
            })
            .catch((error) => {
                console.log(error);
                alert("Failed to send message.");
            });
    };
    return (
        <>
            <header>
                <div className="header">
                    <div className="logo">
                        <img src={ImageLogo} alt="" className='logonav' />
                    </div>
                    <div className="headernavi">
                        <ul>
                            <li><a href="#projects">Projects</a></li>
                            <li><a href="#services">Services</a></li>
                            <li><a href="#about">About</a></li>
                            <li><a href="#stack">Tech</a></li>
                            <li><a href="#contact" class="nav-cta">Get in touch</a></li>
                        </ul>
                    </div>
                </div>
            </header>

            <section id="hero">
                <div class="hero-glow"></div>
                <div class="hero-glow2"></div>
                <div class="badge">Web &amp; AI — Early Stage · Big Vision</div>
                <h1>Building the future<br />with <span class="grad">Web &amp; AI</span></h1>
                <p>Cigna22 is a growing tech startup crafting intelligent web experiences and AI powered solutions. We're just getting started and building boldly.</p>
                <div class="hero-btns">
                    <a href="#projects" class="btn-primary">See our work</a>
                    <a href="#contact" class="btn-ghost">Work with us</a>
                </div>
                <div class="scroll-hint">
                    <span>scroll</span>
                    <div class="scroll-line"></div>
                </div>
            </section>

            <section id="services">
                <div class="text-center">
                    <div class="section-label">What we do</div>
                    <div class="divider"></div>
                    <h2 class="section-title">Our core services</h2>
                    <p class="section-sub">From pixel-perfect interfaces to intelligent automation — we build products that matter.</p>
                </div>
                <div class="services-grid">
                    <div class="service-card">
                        <div class="svc-icon">🌐</div>
                        <h3>Web Development</h3>
                        <p>Modern, performant websites and web apps. Responsive, accessible, and built to scale from day one.</p>
                    </div>
                    <div class="service-card">
                        <div class="svc-icon">🤖</div>
                        <h3>AI Integration</h3>
                        <p>Embedding intelligent features into your product — chatbots, automation pipelines, smart recommendations.</p>
                    </div>
                    <div class="service-card">
                        <div class="svc-icon">📐</div>
                        <h3>UI/UX Design</h3>
                        <p>Interfaces that look stunning and feel effortless. From wireframes to polished, production-ready design.</p>
                    </div>
                    <div class="service-card">
                        <div class="svc-icon">⚡</div>
                        <h3>API & Backend</h3>
                        <p>Robust APIs, serverless functions, and backend systems that power your applications reliably.</p>
                    </div>
                    <div class="service-card">
                        <div class="svc-icon">🧠</div>
                        <h3>AI Solutions</h3>
                        <p>Custom AI models, NLP tools, and LLM-powered applications tailored to your business needs.</p>
                    </div>
                    <div class="service-card">
                        <div class="svc-icon">🚀</div>
                        <h3>Consulting</h3>
                        <p>Strategy and technical guidance to help you choose the right stack, approach, and roadmap.</p>
                    </div>
                </div>
            </section>

            <section id="projects">
                <div class="section-label">Portfolio</div>
                <h2 class="section-title">Our projects</h2>
                <p class="section-sub">A selection of what we've built — web platforms, AI tools, and more on the way.</p>
                <div class="projects-grid">
                    <div class="proj-card">
                        <div class="proj-header blue">🌐</div>
                        <div class="proj-body">
                            <div class="proj-tags"><span class="proj-tag">Web App</span><span class="proj-tag">React</span></div>
                            <h3>Client Portal Platform</h3>
                            <p>A full featured web application for client management with dashboard analytics, user roles, and real-time updates.</p>
                            <a href="#contact" class="proj-link">Learn more</a>
                        </div>
                    </div>
                    <div class="proj-card">
                        <div class="proj-header purple">🤖</div>
                        <div class="proj-body">
                            <div class="proj-tags"><span class="proj-tag">AI</span><span class="proj-tag">NLP</span></div>
                            <h3>AI Chatbot Assistant</h3>
                            <p>An LLM-powered support assistant trained on custom data, deployed across web and messaging platforms.</p>
                            <a href="#contact" class="proj-link">Learn more</a>
                        </div>
                    </div>
                    <div class="proj-card">
                        <div class="proj-header teal">📊</div>
                        <div class="proj-body">
                            <div class="proj-tags"><span class="proj-tag">Dashboard</span><span class="proj-tag">Data Viz</span></div>
                            <h3>Analytics Dashboard</h3>
                            <p>Interactive business intelligence dashboard with real-time data processing and customizable reports.</p>
                            <a href="#contact" class="proj-link">Learn more</a>
                        </div>
                    </div>
                    <div class="proj-card">
                        <div class="proj-header pink">✨</div>
                        <div class="proj-body">
                            <div class="proj-tags"><span class="proj-tag">AI</span><span class="proj-tag">Automation</span></div>
                            <h3>Content AI Pipeline</h3>
                            <p>Automated content generation and optimization pipeline that integrates directly into existing CMS workflows.</p>
                            <a href="#contact" class="proj-link">Learn more</a>
                        </div>
                    </div>
                </div>
            </section>

            <section id="about">
                <div class="about-text">
                    <div class="section-label">About us</div>
                    <h2 class="section-title">Small team,<br />big ambitions</h2>
                    <p>Cigna22 is an early stage tech startup passionate about building at the intersection of web technology and artificial intelligence.</p>
                    <p>We're a lean, focused team that moves fast, ships quality, and works closely with every client. Being early-stage means we're hungry, adaptable, and fully committed to every project we take on.</p>
                    <a href="#contact" class="btn-primary" style={{ display: 'inline-block', marginTop: '1.5rem', textDecoration: 'none' }}>Start a project →</a>
                </div>
                <div class="about-stats">
                    <div class="stat-box">
                        <div class="num">4+</div>
                        <div class="label">Projects delivered</div>
                    </div>
                    <div class="stat-box">
                        <div class="num">2</div>
                        <div class="label">Core focus areas</div>
                    </div>
                    <div class="stat-box">
                        <div class="num">100%</div>
                        <div class="label">Client dedication</div>
                    </div>
                    <div class="stat-box">
                        <div class="num">∞</div>
                        <div class="label">Ideas in the pipeline</div>
                    </div>
                </div>
            </section>

            <section id="stack">
                <div class="text-center">
                    <div class="section-label">Technology</div>
                    <div class="divider"></div>
                    <h2 class="section-title">Our tech stack</h2>
                    <p class="section-sub">We use modern, proven tools to build fast, reliable, intelligent products.</p>
                </div>
                <div class="stack-ticker">
                    <div class="stack-track" id="track">
                        <span class="stack-tag">React</span><span class="stack-tag">React Native</span><span class="stack-tag">Python</span>
                        <span class="stack-tag">HTML</span><span class="stack-tag">CSS</span><span class="stack-tag">JavaScript</span>
                        <span class="stack-tag">MongoDB</span><span class="stack-tag">Java</span><span class="stack-tag">Docker</span><span class="stack-tag">GitHub</span>
                    </div>
                </div>
            </section>

            <section id="contact">
                <div class="contact-inner">
                    <div class="section-label">Contact</div>
                    <h2 class="section-title">Let's Build Together</h2>
                    <p>Have a project in mind? We'd love to hear about it. Drop us a message and we'll get back to you within 24 hours.</p>
                    <form class="contact-form" onSubmit={sendEmail}>
                        <div class="form-row">
                            <div class="form-group">
                                <label>Name</label>
                                <input type="text" placeholder="Your name" name='name' value={formData.name}
                                    onChange={handleChange} required />
                            </div>
                            <div class="form-group">
                                <label>Email</label>
                                <input type="email" placeholder="your@email.com" name='email' value={formData.email}
                                    onChange={handleChange} required />
                            </div>
                        </div>
                        <div class="form-group">
                            <label>Service needed</label>
                            <select name='service' value={formData.service}
                                onChange={handleChange} required>
                                <option value="">Select a service…</option>
                                <option>Web Development</option>
                                <option>AI Integration</option>
                                <option>UI/UX Design</option>
                                <option>API & Backend</option>
                                <option>AI Solution</option>
                                <option>Consulting</option>
                                <option>Other</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label>Message</label>
                            <textarea placeholder="Tell us about your project…" name='message' value={formData.message}
                                onChange={handleChange}></textarea>
                        </div>
                        <button type="submit" class="btn-submit">Send message</button>
                        <p id="form-msg"
                            style={{ textAlign: 'center', color: '#7c5cfc', fontSize: '0.9rem', display: 'none' }}></p>
                    </form>
                </div>
                <div className="contact-outer">
                    <div className="details">
                        <span>Phone Numbers: <p className='details-p'>+94 765858504 / +94 718540100</p></span>
                        <div className="contact-linkedin"
                            onClick={() =>
                                window.open(
                                    "https://www.linkedin.com/company/cigna22/",
                                    "_blank"
                                )
                            }>
                            <img src={LinkedIn} alt="LinkedIn" className='linkedin' />
                            <span>LinkedIn</span>
                        </div>
                        <div className="contact-facebook"
                            onClick={() => window.open(
                                "https://www.facebook.com/profile.php?id=61589426142248",
                                "_blank"
                            )}>
                            <img src={Facebook} alt="Facebook" className='facebook' />
                            <span>Facebook</span>
                        </div>
                        <div className="contact-instagram"
                            onClick={() => window.open(
                                "https://www.instagram.com/cigna22info/",
                                "_blank"
                            )}>
                            <img src={Instagram} alt="Instagram" className='instagram' />
                            <span>Instagram</span>
                        </div>
                    </div>
                </div>
            </section>

            <footer>
                <div class="logo">cigna<span>22</span></div>
                <p>© 2026 Cigna22. All rights reserved.</p>
                <div class="footer-links">
                    <a href="#services">Services</a>
                    <a href="#projects">Projects</a>
                    <a href="#about">About</a>
                    <a href="#contact">Contact</a>
                </div>
            </footer>
        </>
    )
}

export default Page
